/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEventHandler, useEffect, useState } from "react"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import { T勤怠リスト } from "../ZyomuinSyukkinbo_v2/ZyomuinSyukkinbo"
import { TZyomuinSyukkinboDigitachoKintaiRes } from "../../../service/attendance/syukkinbo_v2/TZyomuinSyukkinbo"
import dateUtil from "../../../ts/util/dateUtil"
import { Button, Table } from "react-bootstrap"
import dayjs from "dayjs"
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"
import useEvent from "react-use-event-hook"
import * as wjcCore from "@grapecity/wijmo"
import KyuzituService from "../../../service/master/kyuzitu/kyuzituService"
import { TKyuzituListGetRes } from "../../../service/master/kyuzitu/TKyuzitu"
import { e休日区分 } from "../../../constant/enum/master"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
// import * as wjrTransposed from "@grapecity/wijmo.react.grid.transposed"
// import * as wjcTransposed from "@grapecity/wijmo.grid.transposed"
import * as wjcGrid from "@grapecity/wijmo.grid"
import { e乗務員所定労働時間区分, e勤怠区分 } from "../../../constant/enum/unko"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { 区分分類コード } from "../../../constant/enum/codes"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"
// import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"

/**
 * 乗務員日別勤怠の時間修正用モーダル
 * @param {*} props
 * @return {*}
 */
const DigitachoEditModal: React.FC<
  TModalTypes & {
    デジタコ勤怠GridData?: TZyomuinSyukkinboDigitachoKintaiRes[]
    編集勤怠情報?: T勤怠リスト
    年月: string
    flexGrid: wjcGrid.FlexGrid | null | undefined
    選択行: wjcGrid.Row | null | undefined
    kubunItemsSource: T区分マスタ[] | undefined
  }
> = (props) => {
  //#region [state]

  const [稼働日, set稼働日] = useState<dayjs.Dayjs>()
  const [法定休日フラグ, set法定休日フラグ] = useState(false)
  const [所定休日フラグ, set所定休日フラグ] = useState(false)
  const [休日リスト, set休日リスト] = useState<TKyuzituListGetRes[]>([])
  const 所定労働時間区分_基準労働時間 = props.kubunItemsSource?.find(
    (e) =>
      e.分類コード === 区分分類コード.運行管理_勤怠.乗務員所定労働時間区分 &&
      e.区分コード === e乗務員所定労働時間区分.基準労働時間
  )

  const 所定労働時間Milliseconds =
    所定労働時間区分_基準労働時間?.数値1 == null ? undefined : 所定労働時間区分_基準労働時間?.数値1 * 1000 * 60 * 60

  const [始業日時, set始業日時] = useState<Date | null>()
  const [始業日付, set始業日付] = useState<Date | null>()
  const [始業時刻, set始業時刻] = useState<string>("")
  const [終業日時, set終業日時] = useState<Date | null>()
  const [終業日付, set終業日付] = useState<Date | null>()
  const [終業時刻, set終業時刻] = useState<string>("")
  const [勤務時間, set勤務時間] = useState<string>("")
  const [残業時間, set残業時間] = useState<string>("")
  const [深夜時間, set深夜時間] = useState<string>("")
  const [休出時間, set休出時間] = useState<string>("")
  const [拘束時間, set拘束時間] = useState<string>("")

  const [休憩時間, set休憩時間] = useState<string>("")
  const [休息時間, set休息時間] = useState<string>("")

  const [デジタコ勤怠, setデジタコ勤怠] = useState<TZyomuinSyukkinboDigitachoKintaiRes>()

  const [Messages, setMessages] = useState<{
    infos?: string[]
    warns?: string[]
    errors?: string[]
  }>()

  const [拘束時間計算フラグ, set拘束時間計算フラグ] = useState(false)
  const [勤務時間計算フラグ, set勤務時間計算フラグ] = useState(false)

  //#region [validateState]
  const [始業時刻HasError, set始業時刻HasError] = useState(false)
  const [終業時刻HasError, set終業時刻HasError] = useState(false)
  const [拘束時間HasError, set拘束時間HasError] = useState(false)
  const [残業時間HasError, set残業時間HasError] = useState(false)
  const [深夜時間HasError, set深夜時間HasError] = useState(false)
  const [休出時間HasError, set休出時間HasError] = useState(false)
  const [休憩時間HasError, set休憩時間HasError] = useState(false)
  const [休息時間HasError, set休息時間HasError] = useState(false)
  //#endregion

  //#endregion

  //#region [useEffect]

  // モーダル開閉時処理
  useEffect(() => {
    set始業日付(dayjs(props?.編集勤怠情報?.始業日付 ?? props.編集勤怠情報?.勤務日).toDate())

    set終業日付(dayjs(props.編集勤怠情報?.終業日付 ?? props.編集勤怠情報?.勤務日).toDate())

    set法定休日フラグ(props?.編集勤怠情報 != null && dayjs(props?.編集勤怠情報.勤務日).day() === 0)
    set所定休日フラグ(
      休日リスト.find(
        (i) =>
          props?.編集勤怠情報 != null &&
          dayjs(props?.編集勤怠情報.勤務日).format("YYYYMMDD") === dayjs(i.休日日付).format("YYYYMMDD")
      ) != null
    )

    set稼働日(dayjs(props.編集勤怠情報?.勤務日))

    set始業時刻(dateUtil.toTimeSpanString(props.編集勤怠情報?.始業時刻))
    set終業時刻(dateUtil.toTimeSpanString(props.編集勤怠情報?.終業時刻))

    set勤務時間(dateUtil.toTimeSpanString(props.編集勤怠情報?.勤務時間))
    set拘束時間(dateUtil.toTimeSpanString(props.編集勤怠情報?.拘束時間))
    set残業時間(dateUtil.toTimeSpanString(props.編集勤怠情報?.残業時間))
    set深夜時間(dateUtil.toTimeSpanString(props.編集勤怠情報?.深夜時間))
    set休出時間(dateUtil.toTimeSpanString(props.編集勤怠情報?.休出時間))

    set休憩時間(dateUtil.toTimeSpanString(props.編集勤怠情報?.休憩時間))
    set休息時間(dateUtil.toTimeSpanString(props.編集勤怠情報?.休息時間))

    setデジタコ勤怠(props.デジタコ勤怠GridData?.find((e) => e.デジタコ勤怠ID === props.編集勤怠情報?.デジタコ勤怠ID))
  }, [props.isShow, props.編集勤怠情報, props.デジタコ勤怠GridData, 休日リスト])

  useEffect(() => {
    if (!props.isShow || !dateUtil.CanConvertMilliseconds(始業時刻)) return

    set始業日時(dayjs(始業日付).add(dateUtil.toMilliseconds(始業時刻), "millisecond").toDate())
    // set拘束時間計算フラグ(true)
  }, [始業日付, 始業時刻])

  useEffect(() => {
    if (!props.isShow && !dateUtil.CanConvertMilliseconds(終業時刻)) return

    set終業日時(dayjs(終業日付).add(dateUtil.toMilliseconds(終業時刻), "millisecond").toDate())
    // set拘束時間計算フラグ(true)
  }, [終業日付, 終業時刻])

  // 始業日時と終業日時および休憩時間を変更した際に拘束時間と勤務時間を自動計算する。
  // タイムカードが存在する場合、そちらを優先する
  useEffect(() => {
    if (!props.isShow || !拘束時間計算フラグ || props.編集勤怠情報?.勤務日 == null) return
    const タイムカード出勤日時 = dayjs(
      dayjs(props.編集勤怠情報.勤務日).format("YYYY/MM/DD ") + (props.編集勤怠情報?.タイムカード出勤時刻 ?? "")
    )
    const タイムカード退勤日時 = dayjs(
      dayjs(props.編集勤怠情報?.勤務日).format("YYYY/MM/DD ") + (props.編集勤怠情報?.タイムカード退勤時刻 ?? "")
    )

    const 拘束時間milliseconds = dayjs(
      !wjcCore.isNullOrWhiteSpace(props.編集勤怠情報?.タイムカード退勤時刻 ?? "") ? タイムカード退勤日時 : 終業日時
    ).diff(
      dayjs(
        !wjcCore.isNullOrWhiteSpace(props.編集勤怠情報?.タイムカード出勤時刻 ?? "") ? タイムカード出勤日時 : 始業日時
      )
    )

    set拘束時間(dateUtil.toTimeSpanString(拘束時間milliseconds))

    set拘束時間計算フラグ(false)
    set勤務時間計算フラグ(true)
  }, [始業日時, 終業日時, 拘束時間計算フラグ])

  useEffect(() => {
    if (!props.isShow || !勤務時間計算フラグ) return
    const 拘束時間milliseconds = dateUtil.toMilliseconds(拘束時間)
    const 休憩時間milliseconds = dateUtil.toMilliseconds(休憩時間)

    const 勤務時間Milliseconds = 拘束時間milliseconds - 休憩時間milliseconds

    set勤務時間(dateUtil.toTimeSpanString(勤務時間Milliseconds))

    if (所定労働時間Milliseconds != null && props.編集勤怠情報 != null) {
      // 勤務区分で所定出勤が選ばれていた場合にのみ、
      // 勤務時間をすべて残業時間として設定
      // そうではない場合、基準時間より算出
      if (props.編集勤怠情報.勤怠区分コード === e勤怠区分.所定出勤) {
        set残業時間(dateUtil.toTimeSpanString(勤務時間Milliseconds))
      } else if (稼働日?.day() === 0) {
        set残業時間("00:00")
        set休出時間(dateUtil.toTimeSpanString(勤務時間Milliseconds))
      } else if (勤務時間Milliseconds > 所定労働時間Milliseconds) {
        set残業時間(dateUtil.toTimeSpanString(勤務時間Milliseconds - 所定労働時間Milliseconds))
      } else {
        set残業時間(dateUtil.toTimeSpanString(0))
      }
    }

    set勤務時間計算フラグ(false)
  }, [拘束時間, 休憩時間, 勤務時間計算フラグ])

  useEffect(() => {
    Promise.all([
      new KyuzituService().getList({
        検索年: props.年月,
      }),
    ]).then(([休日Res]) => {
      set休日リスト([
        ...休日Res.data.filter((d) => d.休日区分コード === e休日区分.祝日 || d.休日区分コード === e休日区分.会社休日),
      ])
    })
  }, [props.年月])

  //#endregion

  //#region [handler]

  const 終業日付ChangedHandler = useEvent((core: wjcInput.InputDate | wjcInput.InputTime) => {
    set終業日付(core.value)
  })

  const abstractTimeSpanTextChangedHandler =
    (setValue: React.Dispatch<React.SetStateAction<string>>): ChangeEventHandler<HTMLInputElement> =>
    (e) => {
      setValue(e.currentTarget.value)
    }

  const 始業時刻TextChangedHandler = useEvent(abstractTimeSpanTextChangedHandler(set始業時刻))

  const 終業時刻TextChangedHandler = useEvent(abstractTimeSpanTextChangedHandler(set終業時刻))

  const 残業時間TextChangedHandler = useEvent(abstractTimeSpanTextChangedHandler(set残業時間))
  const 深夜時間TextChangedHandler = useEvent(abstractTimeSpanTextChangedHandler(set深夜時間))
  const 休出時間TextChangedHandler = useEvent(abstractTimeSpanTextChangedHandler(set休出時間))
  const 休憩時間TextChangedHandler = useEvent(abstractTimeSpanTextChangedHandler(set休憩時間))
  const 休息時間TextChangedHandler = useEvent(abstractTimeSpanTextChangedHandler(set休息時間))

  const abstractTimeSpanBlurHandler = (
    setValue: React.Dispatch<React.SetStateAction<string>>,
    setHasError: React.Dispatch<React.SetStateAction<boolean>>,
    value: string
  ) => {
    // 0000、0:00の記述の時のみ、整形を行う
    if (value.match(/^-\d{2}[0-5]\d$/)) {
      setValue(`-${value.slice(1, 3)}:${value.slice(3)}`)
      setHasError(false)
    } else if (value.match(/^\d{2}[0-5]\d$/)) {
      setValue(`${value.slice(0, 2)}:${value.slice(2)}`)
      setHasError(false)
    } else if (value.match(/^-\d{1}:[0-5]\d$/)) {
      const valueArray = value.replace("-", "").split(":")
      setValue(`-0${valueArray[0]}:${valueArray[1]}`)
      setHasError(false)
    } else if (value.match(/^\d{1}:[0-5]\d$/)) {
      const valueArray = value.split(":")
      setValue(`0${valueArray[0]}:${valueArray[1]}`)
      setHasError(false)
    } else {
      setHasError(!isTimeSpan(value))
    }
  }

  const 始業時刻BlurHandler = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
    abstractTimeSpanBlurHandler(set始業時刻, set始業時刻HasError, e.currentTarget.value)
    set拘束時間計算フラグ(true)
  })

  const 終業時刻BlurHandler = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
    abstractTimeSpanBlurHandler(set終業時刻, set終業時刻HasError, e.currentTarget.value)
    set拘束時間計算フラグ(true)
  })

  const 残業時間BlurHandler = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
    abstractTimeSpanBlurHandler(set残業時間, set残業時間HasError, e.currentTarget.value)
  })

  const 深夜時間BlurHandler = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
    abstractTimeSpanBlurHandler(set深夜時間, set深夜時間HasError, e.currentTarget.value)
  })
  const 休出時間BlurHandler = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
    abstractTimeSpanBlurHandler(set休出時間, set休出時間HasError, e.currentTarget.value)
  })
  const 休憩時間BlurHandler = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
    abstractTimeSpanBlurHandler(set休憩時間, set休憩時間HasError, e.currentTarget.value)
    set勤務時間計算フラグ(true)
  })
  const 拘束時間BlurHandler = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
    if (e.currentTarget.readOnly) return

    abstractTimeSpanBlurHandler(set拘束時間, set拘束時間HasError, e.currentTarget.value)
    set勤務時間計算フラグ(true)
  })

  const 休息時間BlurHandler = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
    abstractTimeSpanBlurHandler(set休息時間, set休息時間HasError, e.currentTarget.value)
  })

  const editButtonHandler: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    setMessages(undefined)
    const warns: string[] = []
    if (hasValueError()) {
      ;(始業時刻HasError ||
        終業時刻HasError ||
        残業時間HasError ||
        深夜時間HasError ||
        休出時間HasError ||
        休憩時間HasError ||
        拘束時間HasError ||
        休息時間HasError) &&
        warns.push("時間のフォーマットが不正の項目が存在します。")
    }

    if (warns.length > 0) {
      setMessages({
        warns,
      })
      return
    }

    if (props.編集勤怠情報 == null || props.flexGrid == null || props.選択行 == null) return
    // 値を格納用に加工し、下のグリッドに適用する
    const 始業時刻ミリ秒 = dateUtil.toMilliseconds(dayjs(始業日時).format("HH:mm"))
    const 終業日付 = dayjs(終業日時!).hour(0).minute(0).second(0).millisecond(0).toISOString()
    const 終業時刻ミリ秒 = dateUtil.toMilliseconds(dayjs(終業日時).format("HH:mm"))
    const 勤務時間ミリ秒 = dateUtil.toMilliseconds(勤務時間)
    const 残業時間ミリ秒 = dateUtil.toMilliseconds(残業時間)
    const 深夜時間ミリ秒 = dateUtil.toMilliseconds(深夜時間)
    const 休出時間ミリ秒 = dateUtil.toMilliseconds(休出時間)
    const 拘束時間ミリ秒 = dateUtil.toMilliseconds(拘束時間)
    const 休憩時間ミリ秒 = dateUtil.toMilliseconds(休憩時間)
    const 休息時間ミリ秒 = dateUtil.toMilliseconds(休息時間)

    const castedDataItem = props.選択行.dataItem as T勤怠リスト
    castedDataItem.始業時刻 = 始業時刻ミリ秒.toString()
    castedDataItem.終業日付 = 終業日付
    castedDataItem.終業時刻 = 終業時刻ミリ秒.toString()
    castedDataItem.勤務時間 = 勤務時間ミリ秒.toString()
    castedDataItem.残業時間 = 残業時間ミリ秒.toString()
    castedDataItem.深夜時間 = 深夜時間ミリ秒.toString()
    castedDataItem.休出時間 = 休出時間ミリ秒.toString()
    castedDataItem.拘束時間 = 拘束時間ミリ秒.toString()
    castedDataItem.休憩時間 = 休憩時間ミリ秒.toString()
    castedDataItem.休息時間 = 休息時間ミリ秒.toString()
    castedDataItem.修正フラグ = 1
    props.flexGrid.refresh()
    props.setIsShow(false)
  }

  //#endregion

  //#region [method]

  const isTimeSpan = (v: string) => v.match(/^(|-)\d{2,}:[0-5]\d$/) != null

  const hasValueError = (): boolean => {
    let hasError = false

    //値の整合性を確認
    if (
      始業時刻HasError ||
      終業時刻HasError ||
      残業時間HasError ||
      深夜時間HasError ||
      休出時間HasError ||
      休憩時間HasError ||
      休息時間HasError
    ) {
      hasError = true
    }
    //TODO:数値の妥当性を確認が必要な場合に追加

    return hasError
  }

  //#endregion

  return (
    <ModalOuter
      isShow={props.isShow}
      setIsShow={props.setIsShow}
      title={props.title}
      dialogClassName={"w-32rem"}
      footer={
        <>
          <Button onClick={editButtonHandler}>修正</Button>
        </>
      }>
      <div className="w-100">
        <h3 className={法定休日フラグ ? "holiday-color" : 所定休日フラグ ? "syukkinbo-holiday-color" : ""}>
          {稼働日?.format("YYYY年M月D日(dd)")}
        </h3>
        {props?.編集勤怠情報?.勤怠区分コード === e勤怠区分.所定出勤 && (
          <span className="syukkinbo-holiday-color">所定休日出勤</span>
        )}
      </div>
      <LocalAlertComponent alertSource={Messages} />
      <Table bordered className="align-middle digitacho-edit-table">
        <thead>
          <tr>
            <th className="w-8rem"></th>
            <th className="w-10rem">デジタコ</th>
            <th className="w-10rem">修正後</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th className="fs-5">出勤打刻</th>
            <td>{props.編集勤怠情報?.タイムカード出勤時刻}</td>
            <td>{props.編集勤怠情報?.タイムカード出勤時刻}</td>
          </tr>
          <tr>
            <th className="fs-5">退勤打刻</th>
            <td>{props.編集勤怠情報?.タイムカード退勤時刻}</td>
            <td>{props.編集勤怠情報?.タイムカード退勤時刻}</td>
          </tr>

          <tr>
            <th className="fs-5">始業日付</th>
            <td>
              {デジタコ勤怠 && dayjs(デジタコ勤怠?.始業日付 ?? デジタコ勤怠.勤務日).isValid()
                ? dayjs(デジタコ勤怠?.始業日付 ?? デジタコ勤怠.勤務日).format("YYYY/MM/DD")
                : props.編集勤怠情報 &&
                  dayjs(props.編集勤怠情報?.始業日付 ?? props.編集勤怠情報.勤務日).format("YYYY/MM/DD")}
            </td>
            <td>
              <wjrInput.InputDate readOnly value={始業日付}></wjrInput.InputDate>
            </td>
          </tr>

          <tr>
            <th className="fs-5">始業時刻</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.始業時刻)}</td>
            <td>
              <input
                className={始業時刻HasError ? "is-error form-control text-danger" : "form-control"}
                type="text"
                value={始業時刻}
                onBlur={始業時刻BlurHandler}
                onChange={始業時刻TextChangedHandler}></input>
            </td>
          </tr>

          <tr>
            <th className="fs-5">終業日付</th>
            <td>
              {デジタコ勤怠 && dayjs(デジタコ勤怠?.終業日付 ?? デジタコ勤怠.勤務日).isValid()
                ? dayjs(デジタコ勤怠?.終業日付 ?? デジタコ勤怠.勤務日).format("YYYY/MM/DD")
                : props.編集勤怠情報 &&
                  dayjs(props.編集勤怠情報?.終業日付 ?? props.編集勤怠情報.勤務日).format("YYYY/MM/DD")}
            </td>
            <td>
              <wjrInput.InputDate
                value={終業日付}
                lostFocus={() => {
                  set拘束時間計算フラグ(true)
                }}
                valueChanged={終業日付ChangedHandler}></wjrInput.InputDate>
            </td>
          </tr>

          <tr>
            <th className="fs-5">終業時刻</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.終業時刻)}</td>
            <td>
              <input
                className={終業時刻HasError ? "is-error form-control text-danger" : "form-control"}
                type="text"
                value={終業時刻}
                onBlur={終業時刻BlurHandler}
                onChange={終業時刻TextChangedHandler}></input>
            </td>
          </tr>
          <tr>
            <th className="fs-5">勤務</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.勤務時間)}</td>
            <td>
              <input
                className={"form-control"}
                readOnly
                type="text"
                value={勤務時間}
                onChange={(e) => set勤務時間(e.currentTarget.value)}></input>
            </td>
          </tr>
          <tr>
            <th className="fs-5">残業</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.残業時間)}</td>
            <td>
              <input
                className={残業時間HasError ? "is-error form-control text-danger" : "form-control"}
                type="text"
                value={残業時間}
                readOnly
                onBlur={残業時間BlurHandler}
                onChange={残業時間TextChangedHandler}></input>
            </td>
          </tr>
          <tr>
            <th className="fs-5">深夜</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.深夜時間)}</td>
            <td>
              <input
                className={深夜時間HasError ? "is-error form-control text-danger" : "form-control"}
                type="text"
                value={深夜時間}
                onBlur={深夜時間BlurHandler}
                onChange={深夜時間TextChangedHandler}></input>
            </td>
          </tr>
          <tr>
            <th className="fs-5">休出</th>
            <td>{法定休日フラグ ? dateUtil.toTimeSpanString(デジタコ勤怠?.勤務時間) : "00:00"}</td>
            <td>
              <input
                className={休出時間HasError ? "is-error form-control text-danger" : "form-control"}
                type="text"
                value={休出時間}
                onBlur={休出時間BlurHandler}
                onChange={休出時間TextChangedHandler}></input>
            </td>
          </tr>
          <tr>
            <th className="fs-5">拘束</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.拘束時間)}</td>
            <td>
              <input
                className={拘束時間HasError ? "is-error form-control text-danger" : "form-control"}
                readOnly
                onBlur={拘束時間BlurHandler}
                type="text"
                value={拘束時間}
                onChange={(e) => set拘束時間(e.currentTarget.value)}></input>
            </td>
          </tr>
          <tr>
            <th className="fs-5">休憩</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.休憩時間)}</td>
            <td>
              <input
                className={休憩時間HasError ? "is-error form-control text-danger" : "form-control"}
                type="text"
                value={休憩時間}
                onBlur={休憩時間BlurHandler}
                onChange={休憩時間TextChangedHandler}></input>
            </td>
          </tr>
          <tr>
            <th className="fs-5">休息</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.休息時間)}</td>
            <td>
              <input
                className={休息時間HasError ? "is-error form-control text-danger" : "form-control"}
                type="text"
                value={休息時間}
                onBlur={休息時間BlurHandler}
                onChange={休息時間TextChangedHandler}></input>
            </td>
          </tr>
          <tr>
            <th className="fs-5">荷積</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.荷積時間)}</td>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.荷積時間)}</td>
          </tr>
          <tr>
            <th className="fs-5">荷卸</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.荷卸時間)}</td>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.荷卸時間)}</td>
          </tr>
          <tr>
            <th className="fs-5">待機</th>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.待機時間)}</td>
            <td>{dateUtil.toTimeSpanString(デジタコ勤怠?.待機時間)}</td>
          </tr>
          <tr>
            <th className="fs-5">通行料</th>
            <td className="text-end">{wjcCore.Globalize.format(デジタコ勤怠?.通行料合計 ?? 0, "C0")}</td>
            <td className="text-end">{wjcCore.Globalize.format(デジタコ勤怠?.通行料合計 ?? 0, "C0")}</td>
          </tr>
        </tbody>
      </Table>
    </ModalOuter>
  )
}

export default DigitachoEditModal
